function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useRef, useState } from 'react';
/**
 * Use a prop externally and update the value of the prop internally even when
 * the external state is updated. Typically, React will not rerender a component
 * when props change. This hook allows you to use a prop as a controlled prop
 * which will trigger a rerender when the prop changes externally.
 *
 * @param prop - A prop provided to your component.
 *
 * @returns The element provided to `as` but type cast for use as a JSX element
 * in your component.
 */

export var useControlProp = function useControlProp(prop) {
  var _useState = useState(prop),
      _useState2 = _slicedToArray(_useState, 2),
      controlledProp = _useState2[0],
      setControlledProp = _useState2[1];

  var renders = useRef(0);
  useEffect(function () {
    if (renders.current > 0) {
      setControlledProp(prop);
    }

    renders.current++;
  }, [prop]);
  return [controlledProp, setControlledProp];
};